import React from "react";

// A native <button> gets Space/Enter activation and focus for free, and can be
// named by a <label htmlFor={id}>, which also makes the label text clickable.
const Switch = ({
    id,
    checked,
    onChange,
    disabled = false,
    ariaLabel,
    ariaDescribedBy,
}) => (
    <button
        type="button"
        id={id}
        role="switch"
        aria-checked={!!checked}
        aria-label={ariaLabel}
        aria-describedby={ariaDescribedBy}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={`relative inline-flex h-7 w-12 shrink-0 items-center rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-300 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${
            checked ? "bg-yellow-500" : "bg-gray-200"
        }`}
    >
        <span
            aria-hidden="true"
            className={`inline-block h-6 w-6 rounded-full bg-white shadow transform transition-transform duration-200 ease-in-out ${
                checked ? "translate-x-[22px]" : "translate-x-0.5"
            }`}
        />
    </button>
);

export default Switch;
